import Guide from './Guide';
import User from './User';
import Overlay from './Overlay';
import Container from './Container';
import Survey from './Survey';
import Iframe from './Iframe';
class GuideManager {
  private static _instance: GuideManager;
  private user: User | null = null;
  private guide: Guide | null = null;
  private survey: Survey | null = null;

  public static getInstance(): GuideManager {
    if (!GuideManager._instance) {
      GuideManager._instance = new GuideManager();
    }
    return GuideManager._instance;
  }

  public async start() {
    if (window.top !== window.self) {
      this.startIframe();
    } else {
      this.startMain();
    }
  }

  private async startMain() {
    this.startListeners();
    Container.getInstance();
    await this.waitInitialized();
    this.user = new User();
    await this.user.collectUserInfo();
    this.injectApi();
    this.processQueue();
  }

  private async startIframe() {
    const hasScript = await new Promise(resolve => {
      window.parent.postMessage(
        {
          type: 'CHECK_IF_PARENT_HAS_SCRIPT'
        },
        '*'
      );
      window.addEventListener('message', event => {
        if (event.data.type === 'PARENT_HAS_SCRIPT') {
          resolve(true);
        }
      });
      setTimeout(() => {
        resolve(false);
      }, 1000);
    });
    if (!hasScript) {
      this.startMain();
    } else {
      this.startIframeListeners();
    }
  }

  private startIframeListeners() {
    window.addEventListener('message', event => {
      if (event.data.type === 'CHECK_IF_PARENT_HAS_SCRIPT') {
        event.source?.postMessage({
          type: 'PARENT_HAS_SCRIPT'
        });
      }
    });
    Iframe.getInstance();
  }

  private async waitInitialized() {
    return new Promise(resolve => {
      window.addEventListener('message', event => {
        if (event.data.type === 'INITIALIZED') {
          Container.getInstance().sendMessage({
            type: 'SET_CURRENT_URL',
            url: window.location.href
          });
          resolve(true);
        }
      });
    });
  }

  private startListeners() {
    window.addEventListener('message', (event: MessageEvent) => {
      if (event.data.type === 'GET_CURRENT_URL') {
        Container.getInstance().sendMessage({
          type: 'SET_CURRENT_URL',
          url: window.location.href
        });
      } else if (event.data.type === 'RUN_GUIDE') {
        this.survey?.destroy();
        this.survey = null;

        this.guide = new Guide();
      } else if (event.data.type === 'RUN_SURVEY') {
        this.guide?.destroy();
        this.guide = null;

        this.survey = new Survey();
      } else if (event.data.type === 'DESTROY') {
        this.guide?.destroy();
        this.guide = null;
        this.survey?.destroy();
        this.survey = null;
        Container.getInstance().hide();
        Overlay.getInstance().destroy();
      } else if (event.data.type === 'CHECK_IF_PARENT_HAS_SCRIPT') {
        event.source?.postMessage(
          {
            type: 'PARENT_HAS_SCRIPT'
          },
          { targetOrigin: event.origin }
        );
      }
    });

    this.startUrlChangeListener();
  }

  private startUrlChangeListener() {
    let currentUrl = window.location.href;

    window.addEventListener('popstate', () => {
      if (window.location.href !== currentUrl) {
        currentUrl = window.location.href;
        console.log('currentUrl', currentUrl);
        Container.getInstance().sendMessage({
          type: 'SET_CURRENT_URL',
          url: currentUrl
        });
      }
    });

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function (...args) {
      originalPushState.apply(history, args);
      if (window.location.href !== currentUrl) {
        currentUrl = window.location.href;
        console.log('currentUrl', currentUrl);
        Container.getInstance().sendMessage({
          type: 'SET_CURRENT_URL',
          url: currentUrl
        });
      }
    };

    history.replaceState = function (...args) {
      originalReplaceState.apply(history, args);
      if (window.location.href !== currentUrl) {
        currentUrl = window.location.href;
        console.log('currentUrl', currentUrl);
        Container.getInstance().sendMessage({
          type: 'SET_CURRENT_URL',
          url: currentUrl
        });
      }
    };
  }

  private injectApi() {
    if (!window.Getdemo) {
      window.Getdemo = { q: [] };

      window.Getdemo.c = function (n: string) {
        return function (...args: any[]) {
          window.Getdemo.q.push([n, args]);
        };
      };

      const methods = ['identify'];
      for (let j = 0; j < methods.length; j += 1) {
        window.Getdemo[methods[j]] = window.Getdemo.c(methods[j]);
      }
    }
  }

  private identifyUser = (id?: string, params?: Record<string, any>) => {
    this.user?.identifyUser(id, params);

    Container.getInstance().sendMessage({
      type: 'IDENTIFY_USER',
      userData: this.user?.getInfo()
    });
  };

  private processQueue = () => {
    let hasIdentify = false;

    if (window.Getdemo.q) {
      for (let i = 0; i < window.Getdemo.q.length; i += 1) {
        const [method, args] = window.Getdemo.q[i];
        if (method === 'identify') {
          this.identifyUser(args[0], args[1]);
          hasIdentify = true;
        }
      }
      window.Getdemo.q = [];
    }

    if (!hasIdentify) {
      this.identifyUser();
    }

    window.Getdemo.identify = this.identifyUser;
  };
}

export default GuideManager;
